import type { NodeHandleTone } from "@/components/project/nodes/node-appearance"
import { cn } from "@/lib/utils"
import { NodePill } from "../nodes/primitives/node-pill"
import { NodeStateDot } from "../nodes/node-state-dot"

type ConnectionPillVariant = "canvas" | "sidebar"

export function ConnectedValuePill({
	label,
	variant = "canvas",
	className,
}: {
	label: string
	variant?: ConnectionPillVariant
	className?: string
}) {
	if (variant === "sidebar") {
		return (
			<span
				className={cn(
					"rounded-lg bg-muted/60 px-2 py-0.5 text-xs font-semibold text-foreground",
					className,
				)}
			>
				{label}
			</span>
		)
	}

	return (
		<NodePill
			className={cn(
				"text-[12px] leading-[normal] font-medium text-[var(--node-text)]",
				className,
			)}
			tone="connected"
		>
			{label}
		</NodePill>
	)
}

export function EmptyInputPill({
	tone = "neutral",
	variant = "canvas",
	className,
}: {
	tone?: NodeHandleTone
	variant?: ConnectionPillVariant
	className?: string
}) {
	if (variant === "sidebar") {
		return (
			<span
				className={cn(
					"inline-flex h-7 w-7 items-center justify-center rounded-full bg-muted/60",
					className,
				)}
			>
				<NodeStateDot tone={tone} />
			</span>
		)
	}

	return (
		<NodePill
			className={cn("items-center justify-center", className)}
			tone="socket"
		>
			<NodeStateDot tone={tone} />
		</NodePill>
	)
}
